import { useVatTogglePreference } from './useVatTogglePreference';

/**
 * Applies EXP1486 variant defaults without rendering UI, so pages without the
 * USP bar still get the visitor-aligned VAT mode.
 */
const VatTogglePreferenceSync = () => {
  useVatTogglePreference();
  return null;
};

export default VatTogglePreferenceSync;
